import * as React from 'react';
import c from 'classnames';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink } from '@uncinc/react-drupal-core';

import WysiwygField from '../../WysiwygField';

type Props = {
  title: string,
  subtitle: string,
  link: string,
  titleClassName?: string,
  onClick?: React.MouseEventHandler<any>;
  as?: keyof JSX.IntrinsicElements;
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    subtitle,
    link,
    titleClassName,
    onClick,
    as: Component = 'li',
  } = props;

  const titleClasses = c('LinkList__PrimaryItem__title', titleClassName);
  const classes = c('LinkList__PrimaryItem', 'u-link-box');

  return (
    <Component className={classes}>
      <div className="LinkList__PrimaryItem__content">
        <h3 className={titleClasses}>
          <CoreLink
            to={link}
            title={title}
            onClick={(e: React.MouseEvent<any, MouseEvent>) => {
              if (onClick) {
                onClick(e);
              }
            }}
          />
        </h3>

        <div className="LinkList__PrimaryItem__subtitle">
          <WysiwygField
            property="schema:text"
            html={subtitle}
          />
        </div>
      </div>

      <Icon name="chevron_right" />
    </Component>
  );
};

export default LinkListPrimaryItem;
